var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentPulseEmptyProfiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    stroke: "#5560E2",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19C4.2 16 6.1 14.3 9 14.3C11.9 14.3 13.8 16 14.5 19M16 6.3C17.7 6.8 18.5 8.7 17.8 10.2C17.4 11 16.8 11.5 16 11.7M17 14.4C19 14.4 20.4 15.5 21 17.5",
    stroke: "#5560E2",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentPulseEmptyProfiles);
export default __webpack_public_path__ + "static/media/talent-pulse-empty-profiles.57b81072e28a4bea6a3687fdb9c78888.svg";
export { ForwardRef as ReactComponent };